
import { Component, forwardRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ControlValueAccessor, FormControl, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { debounceTime, tap } from 'rxjs';
import { WorkingDays } from './working-days.type';


@Component({
    selector: 'tm-working-days',
    templateUrl: './working-days.component.html',
    styleUrls: ['./working-days.component.scss'],
    imports: [
        FormsModule,
        MatButtonToggleModule,
        ReactiveFormsModule,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TmWorkingDaysComponent),
            multi: true
        }
    ]
})
export class TmWorkingDaysComponent implements ControlValueAccessor {
    protected workingDaysCtrl = new FormControl<string[]>(null);
    private _value: WorkingDays;
    
    protected get value() {
        return this._value;
    }

    protected set value(value: WorkingDays) {
        this._value = value;
        this.onChange(value);
        this.onTouched();
    }

    onChange: any = () => { };
    onTouched: any = () => { };

    constructor() {
        this.workingDaysCtrl.valueChanges.pipe(
            debounceTime(500),
            tap(workingDays => {
                this.value = mapToWorkingDays(workingDays);
            }),
            takeUntilDestroyed()
        ).subscribe();
    }

    writeValue(value: WorkingDays): void {
        if (value && value !== this.value) {
            this._value = value;

            const workingDays = Object.keys(value).filter(key => value[key])
            //Transform value to string[]
            this.workingDaysCtrl.setValue(workingDays, { emitEvent: false }) ;
        }
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }    
}

const mapToWorkingDays = (workingDays: string[]): WorkingDays => {
    const defaultWorkingDays = {
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false
    }
    return workingDays.reduce((prev, curr) => {
        prev[curr] = true;
        return prev;
    }, defaultWorkingDays)
}